module.exports = __webpack_public_path__ + "static/pegasus-2dd08460ce678409cb55d8dda622cfe0.png";